<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { CloseIcon } from '../icons';
	import DisplayIcon from '../icons/DisplayIcon.svelte';
	import FontSpan from '../typography/FontSpan.svelte';
	import Button from '../button/Button.svelte';

	const dispatchClose = createEventDispatcher<{ confirm: boolean }>();

	export let open = false;

	function toggle() {
		open = !open;
		if (!open) {
			dispatchClose('confirm', false);
		}
	}

	function handleKeydown(event: KeyboardEvent) {
		if (event.key === 'Escape') {
			event.preventDefault();
			event.stopPropagation();
			open = false;
			dispatchClose('confirm', false);
		}
	}
</script>

<svelte:window on:keydown={handleKeydown} />

<div
	class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-50"
	class:opacity-0={!open}
	class:pointer-events-none={!open}
>
	<div class="modal-overlay absolute w-full h-full" />

	<div class="modal-container z-50">
		<div
			role="button"
			tabindex="0"
			on:click={toggle}
			on:keypress={handleKeydown}
			class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50"
		>
			<DisplayIcon size={18} icon={CloseIcon} css="fill-current text-white" />
			<span class="text-sm">(Esc)</span>
		</div>
		<div class="modal-content relative text-left">
			<div class="modal-header">
				<div class="flex grow justify-center">
					<FontSpan varient="body-B-03" class="text-white">Confirm</FontSpan>
				</div>
				<div
					role="button"
					tabindex="0"
					on:keypress
					on:click={toggle}
					class="close-button cursor-pointer"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="42"
						height="39"
						viewBox="0 0 42 39"
						fill="none"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M32.7374 8.60095C33.4209 9.23555 33.4209 10.2644 32.7374 10.899L11.7374 30.399C11.054 31.0337 9.94598 31.0337 9.26256 30.399C8.57915 29.7644 8.57915 28.7356 9.26256 28.101L30.2626 8.60095C30.946 7.96635 32.054 7.96635 32.7374 8.60095Z"
							fill="#55DBD7"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M9.26256 8.60095C9.94598 7.96635 11.054 7.96635 11.7374 8.60095L32.7374 28.101C33.4209 28.7356 33.4209 29.7644 32.7374 30.399C32.054 31.0337 30.946 31.0337 30.2626 30.399L9.26256 10.899C8.57915 10.2644 8.57915 9.23555 9.26256 8.60095Z"
							fill="#55DBD7"
						/>
					</svg>
				</div>
			</div>
			<!--Body-->
			<div class="flex flex-row modal-body">
				<div class="flex flex-col">
					<FontSpan varient="body-R-05" class="text-white text-justify">
						To assign each Lucky ball's code transparently and fairly, Luckyball uses blockchain
						smart contract and external random sources provided by ChainLink. The codes are assigned
						collectively at regular time intervals. Do you want to make a transaction to request
						codes now?
					</FontSpan>
					<div class="flex flex-row flex-grow justify-around pt-4">
						<Button on:click={toggle} type="secondary" class="h-14 px-8" text="Cancel" />
						<Button
							on:click={() => {
								open = false;
								dispatchClose('confirm', true);
							}}
							type="primary"
							class="h-14 px-8"
							text="Confirm"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	.modal-body {
		width: 488px;
		padding: 10px 11px 10px 10px;
		gap: 10px;
	}
	.close-button {
		/* display: flex; */
		width: 39px;
		height: 39px;
		/* padding: 0px 16px; */
		justify-content: center;
		align-items: center;
		gap: 8px;

		border-radius: 6px;
		box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	}
	.modal-header {
		display: flex;
		height: 39px;
		padding: 0px 16px;
		justify-content: center;
		align-items: flex-start;
		gap: 13px;
		flex-shrink: 0;
		align-self: stretch;
	}
	.modal-container {
		display: flex;
		padding: 12px;
		flex-direction: column;
		align-items: center;
		gap: 40px;

		border-radius: 30px;
		border: 1px solid var(--popup-border, #2d2d2d);
		background: var(--bg, #151516);

		/* popup_shadow */
		box-shadow: 0px 0px 20px 0px rgba(189, 189, 189, 0.2);
	}
	.modal-overlay {
		background: rgba(0, 0, 0, 0.8);
		backdrop-filter: blur(8px);
	}

	.modal {
		transition: opacity 0.25s ease;
	}
</style>
